import type { SVGProps } from "react";
import { memo } from "react";
const EKSAnywhere = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M49.93 55.971h2v-2h-2zm-1 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m10-2h2v-2h-2zm-1 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m-8-12h2v-2h-2zm-1 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m10-2h2v-2h-2zm-1 2h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m-13 18h21v-27h-21zm-7.486-.109L14 53.398V26.57l20-11.819v9.7l-10.538 6.704A1 1 0 0 0 23 32v16a1 1 0 0 0 .538.887l13.453 7c.288.15.633.151.921.002l5.018-2.593v9.537zm15.059-34.727L41 24.425v-9.674l20 11.82v10.4h-8V32a1 1 0 0 0-.497-.864m14.427 5.836H63V26a1 1 0 0 0-.492-.86l-22-13a1.01 1.01 0 0 0-1.005-.009c-.311.18-.503.51-.503.87v12a1 1 0 0 0 .496.863L51 32.573v4.398h-7.07a1 1 0 0 0-1 1v8.051l-5.918-6.902 6.83-7.922h-2.661L35 38v-7h-2v17h2v-8l6.668 7.784h1.262v3.261l-5.475 2.83L25 47.391V32.548l10.537-6.705c.288-.184.463-.502.463-.844V13c0-.359-.193-.69-.504-.869a1.01 1.01 0 0 0-1.005.008l-22 13A1 1 0 0 0 12 26v28a1 1 0 0 0 .53.883l24.453 13a1 1 0 0 0 .953-.008l4.994-2.757v1.854a1 1 0 0 0 1 1h23a1 1 0 0 0 1-1v-29a1 1 0 0 0-1-1"
      />
    </g>
  </svg>
);
const Memo = memo(EKSAnywhere);
export default Memo;
